module.exports = __webpack_public_path__ + "img/panache-logo.058d61e9.png";